import { motion } from "framer-motion";

const clients = [
  { name: "Groupe JSV", logo: "https://customer-assets.emergentagent.com/job_automate-scale-4/artifacts/nyqc6lr2_4.png" },
  { name: "Archimat", logo: "https://customer-assets.emergentagent.com/job_automate-scale-4/artifacts/pvyh8ya2_7.png" },
  { name: "PUM Plomberie", logo: "https://customer-assets.emergentagent.com/job_automate-scale-4/artifacts/xptli4eg_8.png" },
  { name: "Liquidation 1740", logo: "https://customer-assets.emergentagent.com/job_automate-scale-4/artifacts/5pj2ljl6_9.png" },
  { name: "Insta-Mix", logo: "https://customer-assets.emergentagent.com/job_automate-scale-4/artifacts/nweg2gj7_10.png" },
  { name: "Kidicare", logo: "https://customer-assets.emergentagent.com/job_automate-scale-4/artifacts/5cy0cbea_11.png" },
  { name: "Café Milano", logo: "https://customer-assets.emergentagent.com/job_automate-scale-4/artifacts/4or7264d_12.png" },
  { name: "San Gennaro", logo: "https://customer-assets.emergentagent.com/job_automate-scale-4/artifacts/dg7x1jyo_13.png" },
  { name: "DGYM Training", logo: "https://customer-assets.emergentagent.com/job_automate-scale-4/artifacts/ss7ug8yp_14.png" },
  { name: "Bottega Pizzeria", logo: "https://customer-assets.emergentagent.com/job_automate-scale-4/artifacts/ahp56fpq_15.png" },
];

export default function ClientLogos() {
  // Duplicate the array for seamless infinite scroll
  const duplicatedClients = [...clients, ...clients];

  return (
    <section
      data-testid="client-logos-section"
      className="py-16 bg-dark overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 mb-8">
        <p className="font-body text-sm text-white/40 text-center uppercase tracking-widest">
          Trusted by leading brands
        </p>
      </div>

      {/* Scrolling Container */}
      <div className="relative">
        {/* Gradient Overlays */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-dark to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-dark to-transparent z-10" />

        {/* Scrolling Logos */}
        <motion.div
          className="flex gap-16 items-center"
          animate={{
            x: [0, -50 * clients.length * 4],
          }}
          transition={{
            x: {
              repeat: Infinity,
              repeatType: "loop",
              duration: 25,
              ease: "linear",
            },
          }}
        >
          {duplicatedClients.map((client, index) => (
            <div
              key={`${client.name}-${index}`}
              data-testid={`client-logo-${index}`}
              className="flex-shrink-0 w-40 h-20 flex items-center justify-center"
            >
              {client.logo ? (
                <img 
                  src={client.logo} 
                  alt={client.name}
                  className="max-w-full max-h-full object-contain opacity-60 hover:opacity-100 transition-opacity duration-300"
                />
              ) : (
                <span className="font-heading font-bold text-sm text-white/30 hover:text-white/60 transition-colors uppercase tracking-tight text-center px-4">
                  {client.name}
                </span>
              )}
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
